export interface SignupRequest {
  code: string;
  email: string;
  password: string;
}

export interface SignupResponse {
  ok: boolean;
  email?: string;
  error?: string;
}

const signupUrl =
  import.meta.env.VITE_AUTH_SIGNUP_URL ?? "/.netlify/functions/warehouse-auth-signup";

function normalizeInviteCode(code: string): string {
  return code.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}

export async function signupWithInviteCode(input: SignupRequest): Promise<SignupResponse> {
  const response = await fetch(signupUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      code: normalizeInviteCode(input.code),
      email: input.email.trim().toLowerCase(),
      password: input.password,
    }),
  });

  const payload = (await response.json().catch(() => ({}))) as SignupResponse;
  if (!response.ok) {
    return {
      ok: false,
      error: payload.error ?? "Signup failed. Try again.",
    };
  }

  return payload;
}
